// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
export function onServiceWorkerUpdateRready() { window.location.reload(true) };